/* eslint-disable no-undef */
/* eslint-disable no-constant-condition */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Fragment, useCallback, useEffect, useState } from 'react';
import React from 'react';
import { Button, InputLabel, RadioGroup, Radio, Table, TableBody, TableContainer, Paper, Grid, Checkbox, FormControlLabel, Box } from '@mui/material';
import { chWtMultiplier } from '../../constants/global-constants';

export const PaymentDetailsNew = ({ info, totalNIS, totalUSD, showItemsTitle }) => {
    const getCur = (cur) => {
        if (Number(cur) === 1)
            return "$";
        return "₪";
    }
    return (
        <Grid item container>
            {<Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '10px', direction: 'rtl' }}>
                {showItemsTitle && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: "bold", fontSize: "16px", color: "#FF3452" }}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {"תיאור הפריט :"}
                    </Grid>
                </Grid>}
                {info.map(data => (data.amt ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {data.label}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        {getCur(data.cur)} {data.amt}
                    </Grid>
                </Grid>:<></>))}
                <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ borderTop: "2px solid grey", fontWeight: "bold" }}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {"סה״כ לתשלום"}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {totalUSD}
                    </Grid>
                </Grid>
                <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ borderTop: "2px solid grey", fontWeight: "bold" }}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {"תשלום בשקלים"}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        ₪ {totalNIS}
                    </Grid>
                </Grid>
            </Grid>}
        </Grid>
    );
}

export default PaymentDetailsNew;